import * as yup from 'yup'
import * as z from 'zod'

export const commonRegex = {
  postalCode: /^\d{5}(?:-\d{4})?$/,
}

export const commonValidationRules = {
  postalCode: yup.string().matches(commonRegex.postalCode),
}

export let zodValidationSchema = {
  postalCode: z.string().regex(commonRegex.postalCode, 'Invalid Zip Code'),
  phone: z.string().min(10, 'Phone must be at least 10 characters'),
}

export let getZodValidationError = (errors: any) =>
  errors.length > 0 ? errors[0]?.message : null

export let shouldShowZodFieldError = (fieldMeta: any) =>
  (fieldMeta.isTouched || fieldMeta.isDirty) && !fieldMeta.isValid
